import type { ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export interface SelectableCardProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Omit for a card that opens something rather than toggles it; it then carries no pressed state. */
  selected?: boolean;
}

/**
 * A card that *is* a choice.
 *
 * Renders a real <button>, so it is tabbable, activates on Enter/Space, and
 * gets the app-wide focus ring. A `<div onClick>` styled as a card is none of
 * those things — this component exists to make the accessible version the
 * path of least resistance. Without `selected` it is a plain clickable card.
 */
export function SelectableCard({
  selected,
  type = 'button',
  className,
  ...props
}: SelectableCardProps) {
  return (
    <button
      type={type}
      aria-pressed={selected}
      className={cn('w-full text-left transition-shadow', selected ? 'card-glow' : 'card', className)}
      {...props}
    />
  );
}
